import { createSlice } from '@reduxjs/toolkit';

import {
  serviceGetConfiguration,
  servicePutConfiguration,
} from 'utils';


const initialState = {
  data: null,
  isLoaded: {
    put: false,
    get: false,
  },
  success: {
    put: false,
    get: false,
  },
  error: {
    put: false,
    get: false,
  },
}

const ConfigurationSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    dataRequest(state, action) {
      return { ...state, isLoaded: { ...state.isLoaded, [action.payload]: true } };
    },

    dataSuccess(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        success: { ...state.success, [action.payload.fetchType]: true },
        data: action.payload.data || null,
      };
    },

    dataFailure(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        error: { ...state.error, [action.payload.fetchType]: action.payload.data?.message },
      };
    },

    cleanUpConfiguration() {
      return initialState;
    },

    cleanUpMessageConfiguration(state) {
      return {
        ...state,        
        isLoaded: initialState.isLoaded,
        success: initialState.success,
        error: initialState.error,
      };
    },

  }
});

const {
  dataRequest,
  dataSuccess,
  dataFailure,
  cleanUpConfiguration,
  cleanUpMessageConfiguration
} = ConfigurationSlice.actions;


const fetchGetConfiguration = () => {
  return (dispatch) => {
    dispatch(dataRequest('get'));
    serviceGetConfiguration()
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'get'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'get'})));
  };
};

const fetchPutConfiguration = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('put'));
    servicePutConfiguration(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'put'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'put'})));
  };
};

export {
  fetchGetConfiguration,
  fetchPutConfiguration,
  cleanUpConfiguration,
  cleanUpMessageConfiguration
};

export default ConfigurationSlice.reducer;
